import { commonTranslations } from '../../../common-assets/js/components/common_translations_fi';

const carTranslations = {
    'review_not_for_dealer_text': 'Keräämme autoarvosteluja toistaiseksi vain yksityisiltä myyjiltä. Kiitos mielenkiinnostasi.',
    'add_to_favourite': 'Lisää suosikiksi',
    'add_to_favourite_double_line': 'Lisää<br />suosikiksi',
    'ad_post': {
        'error_message': {
            'acceleration': 'Anna kiihtyvyys numeroina.',
            'top_speed': 'Anna huippunopeus numeroina.',
            'urban_consumption': 'Anna kaupunkikulutus numeroina.',
            'road_consumption': 'Anna maantiekulutus numeroina.',
            'combined_consumption': 'Anna yhdistetty kulutus numeroina.',
            'curb_weight': 'Anna omamassa numeroina.',
            'curb_weight_consumption': 'Anna omamassa numeroina.',
            'gross_weight': 'Anna kokonaismassa numeroina.',
            'electric_urban_consumption': 'Anna kaupunkikulutus numeroina.',
            'electric_road_consumption': 'Anna maantiekulutus numeroina.',
            'electric_combined_consumption': 'Anna yhdistetty kulutus numeroina.',
            'maximum_charging_power': 'Anna suurin latausteho numeroina.',
            'battery_capacity': 'Tarkista akkukapasiteetti.',
            'battery_capacity_format': 'Anna akkukapasiteetti numeroina enintään kahden desimaalin tarkkuudella.',
            'battery_guarantee_kilometer': 'Anna akkutakuun kilometrimäärä numeroina. Jos takuuta ei ole, jätä kenttä tyhjäksi.',
            'battery_guarantee_month': 'Anna akkutakuun kuukausimäärä numeroina. Jos takuuta ei ole, jätä kenttä tyhjäksi.',
            'body_type': 'Valitse korimalli.',
            'charging_power': 'Anna latausteho numeroina.',
            'charging_power_format': 'Anna latausteho numeroina enintään yhden desimaalin tarkkuudella.',
            'charging_type_maximum_limit': 'Valitse enintään 3 lataustyyppiä.',
            'electric_emission': 'Anna CO2 päästöt numeroina.',
            'electric_range': 'Anna sähköinen kantama numeroina.',
            'emission': 'Anna CO2 päästöt numeroina.',
            'model_type_length': 'Mallitarkennus voi olla enintään 120 merkkiä.',
            'select_model': 'Valitse vaihtokohteiden merkit ja mallit.',
            'to_price': 'Hinnan alaraja ei voi olla suurempi kuin yläraja.',
            'torque': 'Anna vääntö numeroina.',
            'tow_weight_with_brakes': 'Anna vetomassa (jarrullinen) numeroina.',
            'tow_weight_without_brakes': 'Anna vetomassa (ei jarruja) numeroina.',
            'invalid_price': 'Hinnan on oltava vähintään 51 €.',
            'validate_vin_empty': 'Anna rekisterinumero tai ajoneuvon valmistenumero (VIN)',
            'vin': 'Tarkista valmistenumero (VIN)',
            'vin_post_year_1982': 'Valmistenumeron pituus on 17 merkkiä',
            'vin_pre_year_1981': 'Valmistenumeron pituus on 5-17 merkkiä 1981 ja aiemmin valmistetuissa ajoneuvoissa',
            'punchline_mandatory': 'Kampanjatiedot on pakollinen tieto.',
            'punchline_limit': 'Punchline tekstin maksimi sallittu pituus 150 merkkiä',
            'campaign_body_limit': 'Body tekstin maksimi sallittu pituus 5000 merkkiä',
            'prefill_rate_limit_message': 'Olet käyttänyt esitäyttöpyyntöjen enimmäismäärän 3 per 8 viikkoa. Syötä ajoneuvon tiedot manuaalisesti.',
        },
        'lock_field': 'Lukitse tämä kenttä',
        'update_gh_data_text': 'Olet muuttamassa ajoneuvon esitäytettyjä tietoja.',
    },
    'advanced_search': {
        'undriven_only': 'Vain ajamattomat',
        'hide_van_subtype': 'Piilota pakettiautojen korimallit',
        'show_van_subtype': 'Näytä pakettiautojen korimallit...',
        'region_placeholder': 'Alue tai paikkakunta',
        'dealership_selection_limit': 'Voit valita enintään 5 autoliikettä.',
        'dealer_ship_list_placeholder': 'Valitse yksi tai useampi',
        'error_message': {
            'invalid_chargin_power': 'Anna latausteho numeroina 1-1000.',
            'invalid_chargin_power_range': 'Alaraja ei voi olla suurempi kuin yläraja',
            'invalid_co2_range': 'Alaraja ei voi olla suurempi kuin yläraja',
            'invalid_inspection_year': 'Valitse myös "vuosi" alasvetovalikosta, jotka ovat katsastettu tietyn ajan jälkeen.',
            'invalid_registration_year': 'Ole hyvä ja valitse ajoneuvon ensirekisteröintivuosi valikosta',
            'invalid_tow_weight': 'Ole hyvä ja aseta sopiva vetomassan arvo. Kentän arvo tulee olla 1 ja 3500 väliltä',
            'invalid_tow_weight_range': 'Alaraja ei voi olla suurempi kuin yläraja',
        },
    },
    'simple_search': {
        'search_id_message': 'Anna ilmoituksen ID, rekisterinumero tai ajoneuvon valmistenumero',
        'id_search': {
            'required_field_value': 'Anna ilmoituksen ID, rekisterinumero tai ajoneuvon valmistenumero',
            'valid_id_ad_not_found': 'Antamallasi ilmoitus-ID:llä ei tällä hetkellä löydy ilmoitusta.',
            'valid_reg_no_ad_not_found': 'Antamallasi rekisterinumerolla ei löydy ilmoitusta.',
            'valid_vin_no_ad_not_found': 'Valmistenumerolla ei löytynyt ajoneuvoa',
            'wrong_data': 'Anna rekisterinumero muodossa abc-123, ilmoituksen ID muodossa 1234567 tai valmistenumero muodossa 2GNFLFEK1F6224271',
        },
    },
    'search_agent': {
        'search_agent_disabled': 'Hakuvahtisi on poistettu käytöstä, eikä sinulle lähetetä hakuvahtiviestejä. Voit ottaa hakuvahdin takaisin käyttöön koska tahansa.',
        'search_agent_enabled': 'Kiitos vahvistuksesta! Nettiauton hakuvahtisi on käytössä seuraavat kahdeksan viikkoa.',
    },
    'sell_ad': {
        'register_number_invalid': 'Anna rekisterinumero tai ajoneuvon valmistenumero (VIN).',
    },
    'dealer_stat': {
        'kpl': 'kpl',
        'krt': 'krt',
        'press_escape_to_close': 'Paina Escape sulkeaksesi',
        'previous_week': 'viimeiset 7 päivää',
        'previous_month': 'edeltävät 30 päivää',
        'previous_year': 'edelliset 12 kk',
        'customer_contact': {
            'phone': 'Puhelin',
            'email': 'Sähköposti',
            'chat': 'Chat',
            'whatsapp': 'WhatsApp',
        },
        'number_of_contacts': {
            'all': 'Kaikki',
            'phone': 'Puhelin',
            'email': 'Sähköposti',
            'whatsapp': 'WhatsApp',
        },
        'last_week': 'viimeisten 7 päivän aikana',
        'last_month': 'viimeisten 30 päivän aikana',
        'last_year': 'viimeisten 12 kuukauden aikana',
        'key_figures_graph': {
            'page_views': 'Sivulataukset',
            'contacts': 'Yhteydenotot',
            'created_ads': 'Aktiiviset ilmoitukset',
            'removed_ads': 'Poistuneet ilmoitukset',
        },
        'campaigns_visibility': {
            'campaigns': 'Kampanjat',
            'visibility': 'Korostukset',
        },
    },
    'chatbot': {
        'error': {
            'empty_message': 'Kirjoita viesti jatkaaksesi',
            'timeout': 'Pyyntö aikakatkaistiin. Yritä uudelleen.',
            'network': 'Yhteysongelma. Tarkista internet-yhteytesi.',
            'auth': 'Istuntosi on vanhentunut. Päivitä sivu.',
            'server': 'Palvelinvirhe. Yritä myöhemmin uudelleen.',
            'general': 'Tapahtui virhe. Yritä uudelleen.',
        },
    },
};

globalThis.Translations = commonUtils.mergeObjects(commonTranslations, carTranslations);
